module.exports = __webpack_public_path__ + "img/448.09c1838a.jpg";